// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"EntityPage_toolbar_15fUQ","titleLoader":"EntityPage_titleLoader_S0N8M"};